import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "title-bar" }
const _hoisted_2 = {
  key: 1,
  class: "resource-text"
}
const _hoisted_3 = { class: "resource-name masthead-resource-title" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = {
  key: 0,
  class: "bottom description text-deemphasized"
}


import BadgeState from '@components/BadgeState/BadgeState.vue';
import { RouteLocationRaw, useRouter } from 'vue-router';
import Title from '@shell/components/Resource/Detail/TitleBar/Title.vue';
import Top from '@shell/components/Resource/Detail/TitleBar/Top.vue';
import ActionMenu from '@shell/components/ActionMenuShell.vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import RcButton from '@components/RcButton/RcButton.vue';
import TabTitle from '@shell/components/TabTitle';
import { computed, ref, watch } from 'vue';
import { _CONFIG, AS } from '@shell/config/query-params';
import { ExtensionPoint, PanelLocation } from '@shell/core/types';
import ExtensionPanel from '@shell/components/ExtensionPanel.vue';

export interface Badge {
  color: 'bg-success' | 'bg-error' | 'bg-warning' | 'bg-info';
  label: string;
}

export interface TitleBarProps {
  resource: any;
  resourceTypeLabel: string;
  resourceName: string;

  resourceTo?: RouteLocationRaw;
  description?: string;
  badge?: Badge;

  // This should be replaced with a list of menu items we want to render.
  // I don't have the time right now to swap this out though.
  actionMenuResource?: any;
  onShowConfiguration?: (returnFocusSelector: string) => void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    resource: {},
    resourceTypeLabel: {},
    resourceName: {},
    resourceTo: {},
    description: {},
    badge: {},
    actionMenuResource: {},
    onShowConfiguration: { type: Function }
  },
  emits: ['show-configuration'],
  setup(__props: any, { emit: __emit }) {



const store = useStore();
const i18n = useI18n(store);
const router = useRouter();

const emit = __emit;
const showConfigurationDataTestId = 'show-configuration-cta';
const showConfigurationReturnFocusSelector = computed(() => `[data-testid="${ showConfigurationDataTestId }"]`);

const currentView = ref(router?.currentRoute?.value?.query?.as || _CONFIG);

watch(
  () => currentView.value,
  () => {
    router.push({ query: { [AS]: currentView.value } });
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_ui_context = _resolveDirective("ui-context")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Top, null, {
      default: _withCtx(() => [
        _createVNode(Title, { class: "title" }, {
          default: _withCtx(() => [
            _createVNode(_unref(TabTitle), { "show-child": false }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.resourceTypeLabel), 1)
              ]),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createTextVNode()),
            (_ctx.resourceTo)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.resourceTo,
                  class: "resource-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.resourceTypeLabel) + ":\n        ", 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.resourceTypeLabel) + ":\n        ", 1)),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.resourceName), 1),
            _cache[3] || (_cache[3] = _createTextVNode()),
            (_ctx.badge)
              ? _withDirectives((_openBlock(), _createBlock(BadgeState, {
                  key: 2,
                  class: "badge-state",
                  color: _ctx.badge.color,
                  label: _ctx.badge.label
                }, null, 8, ["color", "label"])), [
                  [_directive_ui_context, { store: _unref(store), icon: 'icon-folder', hookable: true, value: _ctx.resource, tag: '__details-state', description: 'Details' }]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [1,2,3]
        }),
        _cache[7] || (_cache[7] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "additional-actions"),
          _cache[5] || (_cache[5] = _createTextVNode()),
          (_ctx.onShowConfiguration)
            ? (_openBlock(), _createBlock(RcButton, {
                key: 0,
                "data-testid": showConfigurationDataTestId,
                class: "show-configuration",
                primary: true,
                "aria-label": _unref(i18n).t('component.resource.detail.titleBar.ariaLabel.showConfiguration', { resource: _ctx.resourceName }),
                onClick: _cache[0] || (_cache[0] = () => emit('show-configuration', showConfigurationReturnFocusSelector.value))
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("i", {
                    class: "icon icon-document",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(i18n).t('component.resource.detail.titleBar.showConfiguration')), 1)
                ]),
                _: 1,
                __: [4]
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createTextVNode()),
          (_ctx.actionMenuResource)
            ? (_openBlock(), _createBlock(ActionMenu, {
                key: 1,
                "button-role": "multiAction",
                resource: _ctx.actionMenuResource,
                "data-testid": "masthead-action-menu",
                "button-aria-label": _unref(i18n).t('component.resource.detail.titleBar.ariaLabel.actionMenu', { resource: _ctx.resourceName })
              }, null, 8, ["resource", "button-aria-label"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3,
      __: [7]
    }),
    _cache[8] || (_cache[8] = _createTextVNode()),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createVNode(ExtensionPanel, {
      resource: _ctx.resource,
      type: _unref(ExtensionPoint).PANEL,
      location: _unref(PanelLocation).DETAILS_MASTHEAD
    }, null, 8, ["resource", "type", "location"])
  ]))
}
}

})